import "./tasks-list-mob.component.scoped.sass";
import React from "react";
import { history } from "react-router-guard";
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

export const TasksListMobComponent = (props: any) => {
  const { data, loading, activeFilters } = props;
  const [t] = useTranslation();

  const openTaskDetails = (task: any) => {
    const { recordTaskId } = task;
    history.push(`/rating/${recordTaskId}`, task);
  };

  return (
    <div className="wrapper">
      {loading && (
        <div className="loader">
          <CircularProgress />
        </div>
      )}
      {!loading &&
        data &&
        data.tasks.map(
          (task: any, index: number) =>
            ((activeFilters.length && activeFilters.includes(task.name)) ||
              activeFilters.length === 0) && (
              <div className="task-wrapper" key={`${index}`}>
                <div className="task">
                  <div className="left-side">
                    <div
                      className="task-icon"
                      style={{ background: task.color }}
                    >
                      <img
                        src={task.icon}
                        alt=""
                        style={{
                          filter: task.lightIcon ? "brightness(5)" : "none",
                        }}
                      />
                    </div>
                    <div className="task-text">{task.name}</div>
                  </div>
                  <div className="right-side">
                    <div className="task-owner">
                      {(task.user.firstName
                        ? task.user.firstName.slice(0, 1) + "."
                        : "") + task.user.lastName}
                    </div>
                    <ChevronRightIcon
                      onClick={openTaskDetails.bind(null, task)}
                    />
                  </div>
                </div>
                {index !== data.tasks.length - 1 && <div className="line" />}
              </div>
            )
        )}
      {!loading && (!data || data.tasks.length === 0) && (
        <div className="no-data">{t("no data available")}</div>
      )}
    </div>
  );
};
